import React from "react";
import "./Realestateauctions.css";
import centerimage from "../../assets/رخصة-المزدات-auction.png"; 
import logoimage from "../../assets/akari-logo.png";
import Footer from "../Footer";

const Realestatauctions = () => {
  return (
    <>
    
    <div className="heading-h1">
    <h1 className="title">خدمة مزادات العقارات</h1>
    </div>
    
      <div className="logo-container">
      <img src={logoimage} alt="Akari Logo" className="logo" />
      </div>
      <div className="content">
      <h2 className="section-title">تعريف الخدمة</h2>
        <p className="text">خدمة مزادات العقارات</p>
        <h2 className="section-title">مقدم الخدمة</h2>
        <p className="text">مكتب عبدالله ناصر العتيق العقاري</p>
        <h2 className="section-title">رقم رخصة مزادات العقارات - 4200000174</h2>
      <div className="image-container">
        <img src={centerimage} alt="Center Image" className="center-image" />
      </div>

      </div>

      <Footer/>
    
      
     
      
      </>
  );
};

export default Realestatauctions;